import request from "@/utils/request"; //记得引入进来

export function login(data) {
    return request({
        method: 'post',
        url: '/reader/auth/login',
        data: data //可以简写为data
    })
}

export function logout() {
    return request({
        method: 'post',
        url: '/logout',
    })
}

export function getUser() {
    return request({
        method: 'get',
        url: '/userinfo'
    })
}

export function changePassword(data) {
    return request({
        method: 'post',
        url: '/users/reset-password',
        params: data
    })
}

export function register(data) {
    return request({
        method: 'post',
        url: '/reader/auth/register-application',
        data: data
    })
}